import type { DevModeLifecycleHookEvent } from '@cli-types/next-adapter/generators.js'
import { DEFAULT_ADMIN_IMPORT_ALIAS } from '@cli-constants/generators.js'
import { renderLifecycleHookCodeRenderer } from '@next-adapter/templates/renderers/generators/dev-mode-integration/lifecycle-hook-code.js'
import { lifecycleHookActionLabel } from './lifecycle-hook-action-label.js'
import { lifecycleHookId } from './lifecycle-hook-id.js'
import { lifecycleHookPhase } from './lifecycle-hook-phase.js'
export function lifecycleHookCode(
  schemaName: string,
  event: DevModeLifecycleHookEvent,
  entityLabel: string,
  adminImportAlias = DEFAULT_ADMIN_IMPORT_ALIAS
): string {
  const actionLabel = lifecycleHookActionLabel(event)

  if (lifecycleHookPhase(event) === 'before') {
    return renderLifecycleHookCodeRenderer({
      kind: 'renderLifecycleHookCodeImportsTemplate',
      props: {
        adminImportAlias: adminImportAlias,
        schemaName: schemaName,
        event: event,
        entityLabel: entityLabel,
        actionLabel: actionLabel
      }
    })
  }

  return renderLifecycleHookCodeRenderer({
    kind: 'renderLifecycleHookCodeImportsDetailsTemplate',
    props: {
      adminImportAlias: adminImportAlias,
      schemaName: schemaName,
      event: event,
      lifecycleHookId: lifecycleHookId(event)
    }
  })
}
